import { BackrsFormField, PriorityPlaylist } from '@backrs_ui/common-ui';

type GetPlaylistDialogFormFieldsProps = Readonly<{
  playlistToEdit?: PriorityPlaylist | null;
}>;

export const playlistDialogFormConfig = ({ playlistToEdit }: GetPlaylistDialogFormFieldsProps) => {
  const fields: BackrsFormField[] = [
    {
      id: 'title',
      name: 'title',
      type: 'text',
      label: 'Playbook Title*',
      placeholder: 'e.g. Financial Todos',
      labelPlacement: 'left',
      autoComplete: 'title',
      rules: {
        required: true,
        maxLength: 50,
      },
      autoFocus: true,
      defaultValue: playlistToEdit?.title || '',
      showMaxLenCharCount: true,
    },
    {
      id: 'description',
      name: 'description',
      type: 'textarea',
      placeholder: 'Add a description for your playbook',
      label: 'Description',
      labelPlacement: 'left',
      autoComplete: 'description',
      divider: true,
      defaultValue: playlistToEdit?.description || '',
    },
    {
      id: 'tags',
      name: 'tags',
      type: 'textarea',
      label: 'Tags',
      labelPlacement: 'left',
      placeholder: 'Add 1-10 keywords to help you find your playbook',
      manualFilterOptions: true,
      defaultValue: '',
      selectOptions: {
        type: 'MULTIPLE',
        renderAsSelect: true,
        chipLayout: 'inline',
        options:
          playlistToEdit?.tags?.map((tag) => ({
            label: tag.title,
            value: tag.title,
          })) || [],
      },
    },
  ];

  return fields;
};
